<template>
  <v-container fluid class="px-0">
    <v-row>
      <v-col cols="12" md="4">
        <v-select :items="giftPurchaseTimeRangeOptions" label="Date" dense outlined v-model="selectedGiftPurchaseTimeRange" :menu-props="{ offsetY: true }" @change="onGiftPurchaseTimeRangeFilterChange" />
      </v-col>
      <v-col cols="12" md="4">
        <v-select :items="giftPurchaseStateOptions" label="State" dense outlined v-model="selectedGiftPurchaseState" :menu-props="{ offsetY: true }" @change="onGiftPurchaseStateFilterChange" />
      </v-col>
      <v-col cols="12" md="4">
        <v-row justify="center" align="center">
          <div class="mt-2">
            {{ openGiftPurchaseRequestAmount }} open
            <span v-if="openGiftPurchaseRequestAmount > 1">requests</span>
            <span v-else>request</span>
          </div>
          <v-divider vertical class="mx-4 mt-2" />
          <div class="mt-2">
            {{ verifiedGiftPurchaseRequestAmount }} completed
            <span v-if="openGiftPurchaseRequestAmount > 1">requests</span>
            <span v-else>request</span>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: "KidPurchasedGiftsFilters",

    data() {
      return {
        giftPurchaseTimeRangeOptions: [
          {
            text: "All",
            value: {
              before_datetime: this.$datetime.getCurrentTimeInSec(),
              after_datetime: "",
            },
          },
          {
            text: "Last 7 days",
            value: {
              before_datetime: this.$datetime.getCurrentTimeInSec(),
              after_datetime: this.$datetime.getPerviousTimeInDaysInSec(7),
            },
          },
          {
            text: "Last 30 days",
            value: {
              before_datetime: this.$datetime.getCurrentTimeInSec(),
              after_datetime: this.$datetime.getPerviousTimeInDaysInSec(30),
            },
          },
          {
            text: "Last 60 days",
            value: {
              before_datetime: this.$datetime.getCurrentTimeInSec(),
              after_datetime: this.$datetime.getPerviousTimeInDaysInSec(60),
            },
          },
          {
            text: "This year",
            value: {
              before_datetime: this.$datetime.getCurrentTimeInSec(),
              after_datetime: this.$datetime.getPerviousTimeInDaysInSec(365),
            },
          },
        ],
        selectedGiftPurchaseTimeRange: {},
        giftPurchaseStateOptions: [
          {
            text: "All",
            value: { state: "" },
          },
          {
            text: "Open request",
            value: { state: "open" },
          },
          {
            text: "Completed request",
            value: { state: "completed" },
          },
        ],
        selectedGiftPurchaseState: {},
      };
    },

    computed: {
      openGiftPurchaseRequestAmount() {
        return this.$store.getters.getGifts().filter((gift) => gift.open).length;
      },
      verifiedGiftPurchaseRequestAmount() {
        return this.$store.getters.getGifts().filter((gift) => gift.approved).length;
      },
    },

    methods: {
      onGiftPurchaseTimeRangeFilterChange() {
        this.$store.commit("setGiftListFilters", {
          timeRange: this.selectedGiftPurchaseTimeRange,
        });

        //reset to first page
        this.$store.commit("setGiftListPaginationInfo", {
          pageSize: 9,
          currentPage: 1,
        });

        this.$emit("fetch-gifts");
      },

      onGiftPurchaseStateFilterChange() {
        this.$store.commit("setGiftListFilters", {
          status: this.selectedGiftPurchaseState.state,
        });

        //reset to first page
        this.$store.commit("setGiftListPaginationInfo", {
          pageSize: 9,
          currentPage: 1,
        });

        this.$emit("fetch-gifts");
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Kids/PurchasedGift/KidPurchasedGiftsFilters.vue